import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';

// constant
import { BaseError } from '../../helpers/BaseError';

// models
import { FormulaAudienceIdModel } from '../../models/formula.model';

// services
import API from '../../services/api';

// query keys
import formulaKeys from './_queryKeys';

export default function useFormulaAudienceMutation(id?: number) {
    const queryClient = useQueryClient();

    return useMutation<
        AxiosResponse<string>,
        BaseError,
        FormulaAudienceIdModel
    >({
        mutationFn: (data: FormulaAudienceIdModel) =>
            API.updateFormulaAudience(id, data),

        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: formulaKeys.all,
            });
        },
    });
}
